export default {
  Nearly30Day: '近30天',
  Operator: '操作人',
  ControlSize: '管控粒度',
  ControlOperat: '管控内容',
  DomainControlContent: '域名管控内容',
  QuintupleControlContent: '五元组管控内容',
  RelatedRule: '关联规则',
  OperatTime: '操作时间',
  ControlLog: '管控日志',
  FlowControlRule: '流量管控规则',
  SearchPH: '搜索来源ip/来源端口/目标ip/目标端口/域名/规则名',
  Ban: '禁用',
  ControlOperating: '管控操作',
  AlertPrompt: '管控日志展示了流量管控规则的禁用和解禁的操作记录，帮助您记录管控行为及管控细节信息，可用于上网行为管控的审计。'
}